import React, { useState, useCallback, memo } from "react";
import { Facebook, Home, Instagram, WhatsApp } from "@mui/icons-material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";

const PwaInstallPrompt = React.lazy(() => import("../../Pages/PwaInstallPrompt"));
const PrimaryDropDownMenu = React.lazy(() => import("./PrimaryDropDownMenu"));
const Searchbar = React.lazy(() => import("./Searchbar"));

const Header = memo(() => {
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);

  const [togglePrimaryDropDown, setTogglePrimaryDropDown] = useState(false);

  const toggleDropDownHandler = useCallback(() => {
    setTogglePrimaryDropDown((prev) => !prev);
  }, []);

  return (
    <>
      <div className="bg-primary-lightGreen fixed top-0 w-full z-50">
        <div className="fw-full px-4 sm:px-6 mx-auto flex justify-between items-center relative text-white font-medium">
          <nav className="flex space-x-4">
            <Link to="/" className="flex items-center">
              <Home className="mr-1" />
              Home
            </Link>
          </nav>

          <nav className="flex space-x-2">
            <a
              href="https://www.facebook.com/share/15NVZUbLCd/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center"
            >
              <Facebook className="text-blue-600 mr-1" />
            </a>
            <a
              href="https://www.instagram.com/siddhi_creatives/profilecard/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center"
            >
              <Instagram className="text-pink-600 mr-1" />
            </a>
            <a
              href="https://wa.me/9057810542?text=Hello%2C%20I%20would%20like%20more%20information%21"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center"
            >
              <WhatsApp className="text-green-600 mr-1" />
            </a>

            <React.Suspense fallback={null}>
              <PwaInstallPrompt />
            </React.Suspense>
          </nav>
        </div>
      </div>

      <header className="bg-primary-blue fixed top-[24px] py-2 w-full z-50">
        <div className="w-full px-4 sm:px-6 mx-auto flex justify-between items-center relative">
          <div className="flex items-center flex-1">
            <Link className="h-8 mr-2 sm:mr-4" to="/">
              <img
                draggable="false"
                className="h-full w-auto object-contain"
                src={logo}
                alt="Siddhi"
              />
            </Link>

            <React.Suspense fallback={null}>
              <Searchbar />
            </React.Suspense>
          </div>

          <div className="flex items-center justify-between ml-2 sm:ml-4 gap-1 sm:gap-6 relative">
            {isAuthenticated === false ? (
              <Link to="/login" className="px-2 text-white font-medium cursor-pointer">
                Login
              </Link>
            ) : (
              <span
                className="userDropDown flex items-center text-white font-medium gap-1 cursor-pointer"
                onClick={toggleDropDownHandler}
              >
                {user.name && user.name.split(" ", 1)}
                <span>
                  {togglePrimaryDropDown ? (
                    <ExpandLessIcon sx={{ fontSize: "16px" }} />
                  ) : (
                    <ExpandMoreIcon sx={{ fontSize: "16px" }} />
                  )}
                </span>
              </span>
            )}

            {togglePrimaryDropDown && (
              <React.Suspense fallback={null}>
                <PrimaryDropDownMenu
                  setTogglePrimaryDropDown={setTogglePrimaryDropDown}
                  user={user}
                />
              </React.Suspense>
            )}

            <Link
              to="/cart"
              className="flex items-center text-white font-medium gap-2 relative"
            >
              <span>
                <ShoppingCartIcon />
              </span>
              {cartItems.length > 0 && (
                <div className="w-5 h-5 p-2 bg-red-500 text-xs rounded-full absolute -top-2 left-3 flex justify-center items-center border border-white">
                  {cartItems.length}
                </div>
              )}
              Cart
            </Link>
          </div>
        </div>
      </header>
    </>
  );
});

export default Header;
